export default {
  name: "权限管理",
  permissionsKey: "",
  icon: "fa fa-envelope-open",
  children: {
    permissionList: {
      name: "权限列表",
      permissionsKey: "",
      path: "/permissionList"
    },
    courseCardList: {
      name: "角色列表",
      permissionsKey: "",
      path: "/roleList"
    },
    userRoleList: {
      name: "用户权限",
      permissionsKey: "",
      path: "/userRoleList"
    }
  }
};
